module.exports = __webpack_public_path__ + "assets/img/33_833_big.2f94c48d.jpg";